
export default [
    {
        path: "/resource/:resourceKey",
        name: "grant_resource",
        component: () => import(/* webpackChunkName: "grant_resource" */ "@/views/authorization/resource/Resource.vue"),
        meta: { requiresAuth: true },
        props: true
    }
]